export default __webpack_public_path__ + "static/media/img-guide-gt-popup-1-at_de.35fe6c83.png";